import { get, post } from './apiHelper';
import { ARCHETYPE_CONFIG, simulateNetworkDelay } from '../config/archetypeConfig';

const archetypeService = {
    // Obtener preguntas del cuestionario
    getQuestions: async () => {
        try {
            const response = await get(ARCHETYPE_CONFIG.ENDPOINTS.QUESTIONS);
            return response;
        } catch (error) {
            console.error('Error fetching archetype questions:', error);
            throw error;
        }
    },

    // Procesar cuestionario
    submitQuiz: async (responses) => {
        try {
            const requestBody = { responses };
            if (process.env.NODE_ENV === 'development') {
                console.log('Sending to backend:', JSON.stringify(requestBody, null, 2));
            }
            const response = await post(ARCHETYPE_CONFIG.ENDPOINTS.SUBMIT, requestBody);
            if (process.env.NODE_ENV === 'development') {
                console.log('Backend response:', response);
            }
            return response;
        } catch (error) {
            console.error('Error submitting archetype quiz:', error);
            throw error;
        }
    },

    // Obtener arquetipo del usuario actual
    getUserArchetype: async () => {
        try {
            // Simular delay de red para mejor UX
            await simulateNetworkDelay();

            const response = await get(ARCHETYPE_CONFIG.ENDPOINTS.GET_USER_ARCHETYPE);
            return response;
        } catch (error) {
            console.error('Error fetching user archetype:', error);
            throw error;
        }
    },

    // Obtener todos los arquetipos
    getAllArchetypes: async () => {
        try {
            const response = await get('users/archetypes');
            return response;
        } catch (error) {
            console.error('Error fetching all archetypes:', error);
            throw error;
        }
    },

    // Obtener arquetipo específico por ID
    getArchetypeById: async (id) => {
        try {
            const response = await get(`users/archetypes/${id}`);
            return response;
        } catch (error) {
            console.error('Error fetching archetype by ID:', error);
            throw error;
        }
    }
};

export default archetypeService; 